export class Answer {
    constructor(p_id, p_chosen, p_title) {
        this.id = p_id;
        this.chosen = p_chosen;
        this.title = p_title;
    }
}